import { Button, Form, Input, Modal } from "antd";
import { useModal } from "@refinedev/antd";
import { useState } from "react";
import s from "../Map-Players/Map-Players.module.scss";
import { addSlugPlayer } from "../../Providers/add-slug-player-provider";

type AddSlugPlayerModalProps = {
  fnlPlayerId: string | number;
  currentSlug?: string | null;
  playerName: string;
  refetchList: () => void;
};

export const AddSlugPlayer = ({
  fnlPlayerId,
  currentSlug,
  playerName,
  refetchList,
}: AddSlugPlayerModalProps) => {
  const { modalProps, show, close } = useModal();
  const [slug, setSlug] = useState(currentSlug ?? "");
  const [loading, setLoading] = useState(false);

  const transliterate = (text: string) => {
    const map: Record<string, string> = {
      а: "a",
      б: "b",
      в: "v",
      г: "g",
      д: "d",
      е: "e",
      ё: "yo",
      ж: "zh",
      з: "z",
      и: "i",
      й: "y",
      к: "k",
      л: "l",
      м: "m",
      н: "n",
      о: "o",
      п: "p",
      р: "r",
      с: "s",
      т: "t",
      у: "u",
      ф: "f",
      х: "h",
      ц: "ts",
      ч: "ch",
      ш: "sh",
      щ: "sch",
      ъ: "",
      ы: "y",
      ь: "",
      э: "e",
      ю: "yu",
      я: "ya",
    };
    return text
      .toLowerCase()
      .replace(/ь/g, "")
      .split("")
      .map((c) => map[c] || c)
      .join("")
      .replace(/[^a-z0-9]/g, "-")
      .replace(/-+/g, "-")
      .trim();
  };

  const handleGenerate = () => {
    if (!playerName) return;
    setSlug(transliterate(playerName));
  };

  const handleSave = async () => {
    if (!slug) return;
    setLoading(true);
    try {
      await addSlugPlayer({ fnlId: fnlPlayerId, slug });
      refetchList();
      close();
    } catch (error: any) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button size="small" onClick={show} block>
        Сгенерировать slug игрока
      </Button>

      <Modal
        title={`Slug игрока: ${playerName}`}
        okText="Сохранить"
        cancelText="Отмена"
        onCancel={close}
        footer={null}
        {...modalProps}
      >
        <Form layout="vertical" className={s.form}>
          <Form.Item label="Slug игрока">
            <div className={s.slug_form}>
              <div className={s.slug_input}>
                <Input
                  value={slug}
                  onChange={(e) => setSlug(e.target.value)}
                  placeholder="slug"
                />
              </div>
              <Button className={s.slug_btn} onClick={handleGenerate}>
                Сгенерировать
              </Button>
              <Button
                className={s.slug_btn}
                type="primary"
                onClick={handleSave}
                loading={loading}
              >
                Сохранить
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
